// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion li {
    border-bottom: 1px solid #f1f2f3;
    padding: 0px;
    width: 100%;
}
.sidenav .sidenav-menu .nav .nav-link {
    display: flex;
    align-items: center;
    line-height: normal;
    padding-top: 0.75rem;
    padding-bottom: 1rem;
    /* position: relative; */
    /* color: #515b7c; */
    font-weight: bold;
    display: block;
    font-size: 20px;
    width: 100%;
    text-align: left;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    text-decoration: none;
}
ul.navbar-nav.align-items-center .btn {
    border-radius: 0px !important;
    margin-right: 20px;
}
.apnapolicyMenuButton,.apnapolicyMenuButton:hover,.apnapolicyMenuButton:focus-visible{
    border: 0px;
    background-color: #fff;
    box-shadow: none;
}
.carousel-item{
    width: auto important;
}
.our-partner-section {
  padding: 30px 0px;
}
#footer {
    background: #252525 !important;
}
section {
    padding: 0px 0px 20px 0px;
}
.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.text-white {
    color: #fff!important;
}
.text-center {
    text-align: center!important;
}
.navbar-dark .navbar-nav .nav-link {
  color: #424e71;
  font-size: 14px;
}
.navbar-dark .navbar-nav .nav-link:focus {
  color: #424e71;
}
#footer ul.social li {
    padding: 3px 0;
}
#footer ul.social li .card {
  margin-bottom: 0px;
  border-radius: 0;
}
#footer ul.social li a, #footer ul.quick-links li a {
   color:#252525;
}
#footer ul.social li a .bi {
  margin-right: 5px;
  font-size: 25px;
  transition: .5s all ease;
}
#footer ul.social li a .bi:hover {
  color: #44986f;
}
.logonavybluecolor{
  color: #25335b;
}
/* YourStyles.css */
.centered-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it's above other content */
}

.centered-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Maintain aspect ratio */
}


@media (max-width: 996px) {
    .hide-on-large-screens {
      display: block;
    }
  }
  @media (min-width: 996px) {
    .hide-on-large-screens {
      display: none;
    }
  }     
  

  @media screen and (max-width: 996px) {
    .hide-on-small-screen {
      display: none;
    }
  }
/* @media (max-width: 768px) {
  .listed {
    display: block;
  }
} */
/* @media (max-width: 768px) {
    .listed {
      display: block;
    }
  } */
  /* @media (max-width: 768px) {
   .nav-item .listed {
      display: block;
    }
  }
  
  @media (min-width: 769px) {
   .nav-item .listed {
      display: none;
    }
  }   */

/* Media query for screens with a width less than 996px */
`, "",{"version":3,"sources":["webpack://./src/HeaderComponent/headerOne.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,4BAA4B;AAChC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;IACI,cAAc;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;GACG,aAAa;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EAGf,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,oCAAoC;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,0BAA0B;AACjD;;;AAGA;IACI;MACE,cAAc;IAChB;EACF;EACA;IACE;MACE,aAAa;IACf;EACF;;;EAGA;IACE;MACE,aAAa;IACf;EACF;AACF;;;;GAIG;AACH;;;;KAIK;EACH;;;;;;;;;;OAUK;;AAEP,yDAAyD","sourcesContent":[".accordion li {\r\n    border-bottom: 1px solid #f1f2f3;\r\n    padding: 0px;\r\n    width: 100%;\r\n}\r\n.sidenav .sidenav-menu .nav .nav-link {\r\n    display: flex;\r\n    align-items: center;\r\n    line-height: normal;\r\n    padding-top: 0.75rem;\r\n    padding-bottom: 1rem;\r\n    /* position: relative; */\r\n    /* color: #515b7c; */\r\n    font-weight: bold;\r\n    display: block;\r\n    font-size: 20px;\r\n    width: 100%;\r\n    text-align: left;\r\n    padding-left: 10px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    font-size: 14px;\r\n    text-decoration: none;\r\n}\r\nul.navbar-nav.align-items-center .btn {\r\n    border-radius: 0px !important;\r\n    margin-right: 20px;\r\n}\r\n.apnapolicyMenuButton,.apnapolicyMenuButton:hover,.apnapolicyMenuButton:focus-visible{\r\n    border: 0px;\r\n    background-color: #fff;\r\n    box-shadow: none;\r\n}\r\n.carousel-item{\r\n    width: auto important;\r\n}\r\n.our-partner-section {\r\n  padding: 30px 0px;\r\n}\r\n#footer {\r\n    background: #252525 !important;\r\n}\r\nsection {\r\n    padding: 0px 0px 20px 0px;\r\n}\r\n.container {\r\n    width: 100%;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n.text-white {\r\n    color: #fff!important;\r\n}\r\n.text-center {\r\n    text-align: center!important;\r\n}\r\n.navbar-dark .navbar-nav .nav-link {\r\n  color: #424e71;\r\n  font-size: 14px;\r\n}\r\n.navbar-dark .navbar-nav .nav-link:focus {\r\n  color: #424e71;\r\n}\r\n#footer ul.social li {\r\n    padding: 3px 0;\r\n}\r\n#footer ul.social li .card {\r\n  margin-bottom: 0px;\r\n  border-radius: 0;\r\n}\r\n#footer ul.social li a, #footer ul.quick-links li a {\r\n   color:#252525;\r\n}\r\n#footer ul.social li a .bi {\r\n  margin-right: 5px;\r\n  font-size: 25px;\r\n  -webkit-transition: .5s all ease;\r\n  -moz-transition: .5s all ease;\r\n  transition: .5s all ease;\r\n}\r\n#footer ul.social li a .bi:hover {\r\n  color: #44986f;\r\n}\r\n.logonavybluecolor{\r\n  color: #25335b;\r\n}\r\n/* YourStyles.css */\r\n.centered-image-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.8); /* Semi-transparent background */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 999; /* Ensure it's above other content */\r\n}\r\n\r\n.centered-image {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain; /* Maintain aspect ratio */\r\n}\r\n\r\n\r\n@media (max-width: 996px) {\r\n    .hide-on-large-screens {\r\n      display: block;\r\n    }\r\n  }\r\n  @media (min-width: 996px) {\r\n    .hide-on-large-screens {\r\n      display: none;\r\n    }\r\n  }     \r\n  \r\n\r\n  @media screen and (max-width: 996px) {\r\n    .hide-on-small-screen {\r\n      display: none;\r\n    }\r\n  }\r\n/* @media (max-width: 768px) {\r\n  .listed {\r\n    display: block;\r\n  }\r\n} */\r\n/* @media (max-width: 768px) {\r\n    .listed {\r\n      display: block;\r\n    }\r\n  } */\r\n  /* @media (max-width: 768px) {\r\n   .nav-item .listed {\r\n      display: block;\r\n    }\r\n  }\r\n  \r\n  @media (min-width: 769px) {\r\n   .nav-item .listed {\r\n      display: none;\r\n    }\r\n  }   */\r\n\r\n/* Media query for screens with a width less than 996px */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
